













import { Component, Vue,Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter, Mutation } from "vuex-class";
import { pageDataType } from "../types";
import { HOST } from "../global";
//import { SmoothScroll } from "../common";
import { pageData } from "@/store/pageData";
import HomeTextblock from "../components/HomeTextblock.vue";
import HomeFullimg from "../components/HomeFullimg.vue";
import HomeImgtext from "../components/HomeImgtext.vue";
import HomeSlider from "../components/HomeSlider.vue";
import HeaderSlider from "../components/HeaderSlider.vue";
@Component({
  name: "HomePage",
  components: {
    text_and_header: HomeTextblock,
    fullwidth_image: HomeFullimg,
    text_with_image: HomeImgtext,
    slider: HomeSlider,
    HeaderSlider
   
  }
})
export default class HomePage extends Vue {
@Prop() public pageData!: pageDataType;
@Getter("pageType") public pageType!: string | null;
  //@Getter("pageType") public pageType!: string | null;
  public scroll: any | null = null;
  public HOST: string = HOST;
   public pageLoaded: boolean = false;
  passLoaded(){
    this.$emit('loaded');
  }
  // mounted() {
  //     console.log(this.pageData.header);
  //   this.$nextTick(() => {
  //       this.scroll = new SmoothScroll();
  //       console.log(this.scroll);
  //   });
  // }
}
